import { render, staticRenderFns } from "./UrlsModal.vue?vue&type=template&id=68d28b89&scoped=true&"
import script from "./UrlsModal.vue?vue&type=script&lang=js&"
export * from "./UrlsModal.vue?vue&type=script&lang=js&"
import style0 from "./UrlsModal.vue?vue&type=style&index=0&id=68d28b89&prod&lang=scss&"
import style1 from "./UrlsModal.vue?vue&type=style&index=1&id=68d28b89&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68d28b89",
  null
  
)

export default component.exports